import React, {Component} from "react";

class Dimensions extends Component {

    render() {
        return (
            <div className="container-fluid">
                <p> 当社製造可能サイズ
                </p>
                <p> 片面・両面基板については
                </p>
                <p> 最小6mm×6mmから400mm×500mmサポートしております。
                </p>
                <p> 4層・6層基板については
                </p>
                <p> 最小6mm×6mmから300mm×300mmポートしております。
                </p>
                <p> 板厚による製造可能サイズについて
                </p>
                <br/>
                <table className="table table-bordered">
                    <thead className="thead-dark">
                    <tr>
                        <th scope="col">板厚</th>
                        <th scope="col">層数</th>
                        <th scope="col">製造可能サイズ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>ｔ1.0からt1.6mm</td>
                        <td>片面・両面基板</td>
                        <td>最小6mm×6mm 最大400mm×500mm</td>
                    </tr>
                    <tr>
                        <td>ｔ1.6からt1.6mm</td>
                        <td>4層・6層基板</td>
                        <td>最小6mm×6mm 最大300mm×300mm</td>
                    </tr>
                    <tr>
                        <td>ｔ0.4からt0.8mm</td>
                        <td>片面・両面基板</td>
                        <td>最小6mm×10mm 最大300mm×300mm</td>
                    </tr>
                    <tr>
                        <td>ｔ0.4からt0.6mm</td>
                        <td> 片面・両面基板</td>
                        <td>最小10mm×10mm 最大300mm×300mm</td>
                    </tr>
                    </tbody>
                </table>
                <br/>


                <p>
                    ※20mm×20mm以下の場合はフライング検査が対応できません、フライング検査が必要な場合は、20mm×20mm以上確保して下さい。
                </p>

            </div>
        );
    }
}

export default Dimensions;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/Dimensions.js